export enum StartProjectTableAction {
    Create,
    Edit,
    Delete,
    ToDo,
    InProgress,
    Done,
    Checked,
    Unchecked,
    AssignedEmployee,
    UnassignedEmployee
}
